import {
  ArrowDownIcon,
  ArrowUpIcon,
  isMobileAtom,
  useRecoil,
} from '@orcar/common-d2c';
import { useState } from 'react';
import styled from 'styled-components';

type FaqCardProps = {
  query: string;
  answer: string;
};

const FaqCard = ({ query, answer }: FaqCardProps) => {
  const [isOpened, setIsOpened] = useState(false);
  const { recoilValue: isMobile } = useRecoil(isMobileAtom);
  return (
    <Wrapper isMobile={isMobile}>
      <QuestionBox onClick={() => setIsOpened(!isOpened)}>
        <Question isMobile={isMobile}>{query}</Question>

        {isOpened ? (
          <ToggleIcon src={ArrowUpIcon} width={11} height={6} alt='토글' />
        ) : (
          <ToggleIcon src={ArrowDownIcon} width={11} height={6} alt='토글' />
        )}
      </QuestionBox>
      {isOpened && <Answer isMobile={isMobile}>{answer}</Answer>}
    </Wrapper>
  );
};

export default FaqCard;

const Wrapper = styled.div<{ isMobile: boolean }>`
  width: ${({ isMobile }) => (isMobile ? '320px' : '777.6px')};
  display: flex;
  flex-direction: column;
  padding: ${({ isMobile }) => (isMobile ? '20px 0' : '30px 0')};
  border-bottom: 1px solid ${({ theme }) => theme.COLOR.GREY_05};
  margin: ${({ isMobile }) => isMobile && '0 auto'};
`;

const QuestionBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`;

const Question = styled.div<{ isMobile: boolean }>`
  ${({ theme }) => theme.FONT.H4};
  font-weight: 500;
  font-size: ${({ isMobile }) => isMobile && '16px'};
`;

const ToggleIcon = styled.img`
  cursor: pointer;
`;

const Answer = styled.p<{ isMobile: boolean }>`
  margin: ${({ isMobile }) =>
    isMobile ? '16px 40px 24px 0' : '16px 78px 0 0px'};
  ${({ theme, isMobile }) => (isMobile ? theme.FONT.B2 : theme.FONT.B1)};
  font-weight: 300;
  white-space: pre-line;
`;
